import {Component, ElementRef, OnInit, ViewChild, OnDestroy} from "@angular/core";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { LoadingService } from "../../core/services/loading.service";
import { DefaultPageSize } from "../../core/dto/defaultPage.size";
import { Pagination } from "../../core/dto/pagination";
import { ItineraryService } from "../../core/services/itinerary.service";
import { ItineraryTemplatesService } from "../../core/services/itinerary-templates.service";
import { Clipboard } from "@angular/cdk/clipboard";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";
import {lowerCase, round} from "lodash";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AppUtils } from "../../core/config/app.utils";
import { SettingService } from "../../core/services/setting.service";
import { JsReportService } from "../../core/services/js-report.service";
import { LanguageService } from "../../core/services/language.service";
import { SETTINGS } from "../../core/config/common.settings";
import * as moment from "moment";
import { geoJSONManager } from "../../core/ult-functions/geo";
import { MapboxService } from "../../core/services/mapbox.service";
import { CountryService } from "../../core/services/country.service";
import { Router } from "@angular/router";
import { data } from "autoprefixer";
import {
  ViewExperiencesContentComponent
} from "./view-content-modal/view-experiences-content/view-experiences-content.component";
import { ViewAgentComponent } from "./view-agent/view-agent.component";
import {
  AddEditDestinationContentComponent
} from "./add-edit-content-modal/add-edit-destination-content/add-edit-destination-content.component";
import {ExportContentComponent} from "../../modules/shared/export-content/export-content.component";
import {WordReportService} from "../../core/services/word-report.service";
import { environment } from '../../../environments/environment';
import { TranslocoService } from "@ngneat/transloco";
import { Subscription } from "rxjs";
import { UserService } from "../../core/services/user.service";
import { AuthService } from "../../modules/auth/services/auth.service";

interface ItineraryCustomer {
  name: string;
  createdAt: any;
}

@Component({
  selector: "app-itineraries",
  templateUrl: "./itineraries.component.html",
  styleUrls: ["./itineraries.component.scss"],
})
export class ItinerariesComponent implements OnInit, OnDestroy {

  constructor(
    private loading: LoadingService,
    private itineraryService: ItineraryService,
    private itineraryTemplatesService: ItineraryTemplatesService,
    private clipboard: Clipboard,
    private messageService: NzMessageService,
    private modal: NzModalService,
    private fb: FormBuilder,
    private countryService: CountryService,
    private settingService: SettingService,
    private reportService: JsReportService,
    private wordReportService: WordReportService,
    private languageService: LanguageService,
    private mapBoxService: MapboxService,
    private router: Router,
    private message: NzMessageService,
    private nzModalService: NzModalService,
    private translocoService: TranslocoService,
    private userService: UserService,
    public authService: AuthService,
  ) {
  }

  itineraries: any;
  pageSize = new DefaultPageSize();
  sortField = "";
  sortOrder: any;
  itinerarySearchName = "";

  sendEmailIsVisible = false;
  sendEmailConfirmIsVisible = false;
  emailForm: any;
  formErrors: any = {
    sendEmailTo: {},
    sendEmailCc: {},
    sendEmailSubject: {},
  };
  sendInfo: any;
  modalTitle: any;
  modalTitleConfirmBox: any;
  subject = "";
  sortColumn = {
    compareName: (a: ItineraryCustomer, b: ItineraryCustomer) =>
      a?.name?.localeCompare(b.name),
    compareDate: (a: ItineraryCustomer, b: ItineraryCustomer) => {
      return (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any);
    },
  };

  data: any;
  organizationSetting: any;
  protected countries: any = [];
  protected citiesByCountry: any = [];
  languages: any[] = [];
  countriesJson: any = [];
  protected itineraryId: any;
  attachWithPDFChecked = false;
  protected readonly SETTINGS = SETTINGS;
  // statusChangeModel
  isStatusChangeVisible = false;
  statusChangeRemarks = "";
  selectedStatus = "";
  selectedItinerary: any;
  archieved = false;
  visible = false;
  lastFilterKey = '';
  creators: any[] = [];
  selectedCreator: string | null = null;
  isTableViewModalVisible = false;
  columnVisibility: Record<string, boolean> = {};
  tempColumnVisibility: Record<string, boolean> = {};
  readonly tableColumns = [
    { key: 'referenceNumber', label: 'itineraries.list.table.referenceNumber' },
    { key: 'clientViews', label: 'itineraries.list.table.clientViews' },
    { key: 'customerName', label: 'itineraries.list.table.customerName' },
    { key: 'itineraryTitle', label: 'itineraries.list.table.itineraryTitle' },
    { key: 'arrival', label: 'itineraries.list.table.arrival' },
    { key: 'departure', label: 'itineraries.list.table.departure' },
    { key: 'days', label: 'itineraries.list.table.days' },
    { key: 'pax', label: 'itineraries.list.table.pax' },
    { key: 'language', label: 'itineraries.list.table.language' },
    { key: 'type', label: 'itineraries.list.table.type' },
    { key: 'currency', label: 'itineraries.list.table.currency' },
    { key: 'creator', label: 'itineraries.list.table.creator' },
    { key: 'status', label: 'itineraries.list.table.status' },
    { key: 'created', label: 'itineraries.list.table.created' },
  ];
  typeFilters: { text: string; value: string }[] = [];
  statusFilters: { text: string; value: string }[] = [];
  languageFilters = [...this.languages];
  private langSub: Subscription | undefined;
  private brandSub: Subscription | undefined;

  filterTypeFn = (selected: any, item: any): boolean => {
    const vals = Array.isArray(selected) ? selected : selected != null ? [selected] : [];
    return !vals.length || vals.includes(item?.tour?.type);
  };

  filterLanguageFn = (selected: any, item: any): boolean => {
    const vals = Array.isArray(selected) ? selected : selected != null ? [selected] : [];
    return !vals.length || vals.includes(item?.tour?.language);
  };

  filterStatusFn = (selected: any, item: any): boolean => {
    const vals = Array.isArray(selected) ? selected : selected != null ? [selected] : [];
    return !vals.length || vals.includes(item?.status);
  };

  ngOnInit(): void {
    this.buildFilters();
    this.langSub = this.translocoService.langChanges$.subscribe(() => this.buildFilters());
    this.getCountries().then();
    this.getLanguages().then();
    this.getCreators().then();
    this.emailForm = this.fb.group({
      sendEmailTo: [[], [Validators.required, this.emailValidator]],
      sendEmailCc: [[], [this.emailValidator]],
      sendEmailSubject: [this.subject, [Validators.required]],
    });
    this.emailForm.valueChanges.subscribe((form: any) => {
      AppUtils.getFormErrors(this.emailForm, this.formErrors);
    });
    this.loadOrganizationSettings();
    this.initializeColumnVisibility();
    this.loadColumnPreferences().then();
  }

  async loadOrganizationSettings(): Promise<void> {
    const loggedUser = this.authService.getLoggedInUser();
    this.brandSub = this.settingService.onBrandChange.subscribe((brand: any) => {
      this.organizationSetting = brand;
    });
    if (loggedUser?.userId) {
      await this.settingService.findBrand(loggedUser.userId);
    }
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
    this.brandSub?.unsubscribe();
  }

  buildFilters(): void {
    const t = this.translocoService.translate.bind(this.translocoService);
    this.typeFilters = [
      { text: t('itineraries.list.types.b2b'), value: 'B2B' },
      { text: t('itineraries.list.types.b2c'), value: 'B2C' },
    ];
    this.statusFilters = [
      { text: t('itineraries.list.statuses.draft'), value: SETTINGS.ITINERARY_STATUSES.DRAFT },
      { text: t('itineraries.list.statuses.sent'), value: SETTINGS.ITINERARY_STATUSES.SENT },
      { text: t('itineraries.list.statuses.followUp'), value: SETTINGS.ITINERARY_STATUSES.FOLLOW_UP },
      { text: t('itineraries.list.statuses.confirm'), value: SETTINGS.ITINERARY_STATUSES.CONFIRMED },
      { text: t('itineraries.list.statuses.invoiceSent'), value: SETTINGS.ITINERARY_STATUSES.INVOICE_SENT },
      { text: t('itineraries.list.statuses.paid'), value: SETTINGS.ITINERARY_STATUSES.PAID },
      { text: t('itineraries.list.statuses.lost'), value: SETTINGS.ITINERARY_STATUSES.LOST },
      { text: t('itineraries.list.statuses.cancel'), value: SETTINGS.ITINERARY_STATUSES.CANCELLED },
    ];
  }

  setDefaultClientMail(event: any): void {
    const eventArr: any[] = [];
    if (event.includes(this.sendInfo.email)) {
      return;
    } else {
      // event.forEach((res: any) => {
      //   eventArr.push(res);
      // });
      // eventArr.unshift(this.sendInfo.email);
      this.emailForm.get("sendEmailTo").patchValue(event);
      // this.formErrors.sendEmailTo.remove = true;
      return;
    }
  }

  emailValidator = (control: FormControl) => {
    let isEmail = false;
    control.value.forEach((val: any) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!regex.test(val as string)) {
        isEmail = true;
      }
    });
    if (isEmail) {
      return {email: true};
    } else {
      return {};
    }
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.loading.start();
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.filter = params.filter;
    const langVals = params.filter.find(f => f.key === 'language')?.value ?? [];
    const typeVals = params.filter.find(f => f.key === 'type')?.value ?? [];
    const statusValRaw = params.filter.find(f => f.key === 'status')?.value;
    const statusVals = Array.isArray(statusValRaw) ? statusValRaw : statusValRaw != null ? [statusValRaw] : [];
    const currentSort = params.sort.find(item => item.value !== null);
    // Detect if filters changed (including language)
    const currentFilterKey = JSON.stringify(params.filter);

    if (currentFilterKey !== this.lastFilterKey) {
      this.pageSize.pageIndex = 1;
      this.lastFilterKey = currentFilterKey;
    }else{
      this.pageSize.pageIndex = params.pageIndex;
    }
    this.sortOrder =
      (currentSort && AppUtils.getSortOrder(currentSort.value)) || null;
    const keyword = this.itinerarySearchName;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
      langKeyword: langVals.length !== 0 ? langVals : "",
      type: typeVals.length !== 0 ? typeVals : "",
      status: statusVals.length !== 0 ? statusVals[0] : "",
      archieved: this.archieved,
      creator: this.selectedCreator || ""
    });
    this.itineraryService.getPagedItineraries(payload).then((object: any) => {
      this.itineraries = object.data;
      this.pageSize.length = object.metadata[0]?.total;
      this.loading.stop();
    });
  }

  search(): void {
    this.loading.start();
    const keyword = this.itinerarySearchName;
    this.pageSize.pageIndex = 1;
    const langVals = this.pageSize.filter.find((f: any) => f.key === 'language')?.value ?? [];
    const typeVals = this.pageSize.filter.find((f: any) => f.key === 'type')?.value ?? [];
    const statusValRaw = this.pageSize.filter.find((f: any) => f.key === 'status')?.value;
    const statusVals = Array.isArray(statusValRaw) ? statusValRaw : statusValRaw != null ? [statusValRaw] : [];
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
      langKeyword: langVals.length !== 0 ? langVals : "",
      type: typeVals.length !== 0 ? typeVals : "",
      status: statusVals.length !== 0 ? statusVals[0] : "",
      archieved: this.archieved,
      creator: this.selectedCreator || ""
    });
    this.itineraryService.getPagedItineraries(payload).then((object: any) => {
      this.itineraries = object.data;
      this.pageSize.length = object.metadata[0]?.total;
      this.loading.stop();
    });
  }

  reset(): void {
    this.itinerarySearchName = "";
    this.selectedCreator = null;
    this.languageFilters = this.languageFilters.map(f => ({ ...f, byDefault: false }));
    this.typeFilters = this.typeFilters.map(f => ({ ...f, byDefault: false }));
    this.statusFilters = this.statusFilters.map(f => ({ ...f, byDefault: false }));
    this.search();
  }

  deleteItinerary(id: string): void {
    this.loading.start();
    this.itineraryService.deleteItinerary(id).then(() => {
      this.messageService.success(this.translocoService.translate("itineraries.messages.deleted"));
      this.onReload();
    });
  }

  archiveItinerary(id: string, archive: boolean): void {
    const payload = {
      _id: id,
      isArchived: !archive,
      ...( !archive
          ? { isSharingEnabled: false }
          : {}
      )
    };
    this.loading.start();
    this.itineraryService.updateItinerary(payload).then(() => {
      this.messageService.success(
        this.translocoService.translate(
          !archive ? "itineraries.messages.archived" : "itineraries.messages.unarchived"
        )
      );
      this.loading.stop();
      this.onReload();
    });
  }

  revokeAccessItinerary(id: string, access: boolean): void {
    this.loading.start();
    this.itineraryService.updateItinerary({_id: id, isSharingEnabled: !access}).then(() => {
      this.messageService.success(
        this.translocoService.translate(
          !access ? "itineraries.messages.accessEnabled" : "itineraries.messages.accessDisabled"
        )
      );
      this.loading.stop();
      this.onReload();
    });
  }

  revokeLinkExpiration(id: string, expiration: boolean): void {
    this.loading.start();
    this.itineraryService.updateItinerary({_id: id, isLinkExpirationEnabled: !expiration}).then(() => {
      this.messageService.success(
        this.translocoService.translate(
          !expiration ? "itineraries.messages.linkExpirationEnabled" : "itineraries.messages.linkExpirationDisabled"
        )
      );
      this.loading.stop();
      this.onReload();
    });
  }

  sortByName(): void {
    this.sortField = "full_name";
  }

  copyShareLink(data: any): void {
    const theme = SETTINGS.THEME_TYPES_NAVI_B2C.find(theme => theme.value === data.tour.themeType);
    const params = new URLSearchParams({ rretMgxg: "nono" });
    const baseUrl = this.getHostnameUrl();
    this.clipboard.copy(`${baseUrl}${theme?.url}/${data._id}/${true}?${params.toString()}`);
    this.messageService.success(this.translocoService.translate("itineraries.messages.previewLinkCopied"));
  }

  copyEditableLink(data: any): void {
    const theme = SETTINGS.THEME_TYPES_NAVI_B2B.find(theme => theme.value === data.tour.themeType);
    const params = new URLSearchParams({ rretMgxg: "nono" });
    const baseUrl = this.getHostnameUrl();
    this.clipboard.copy(`${baseUrl}${theme?.url}/${data._id}/${false}?${params.toString()}`);
    this.messageService.success(this.translocoService.translate("itineraries.messages.editableLinkCopied"));
  }

  async generateEditableLink(data: any): Promise<void> {
    const updatePayload = {
      ...data.b2b,
      time: moment()
    };
    const theme = SETTINGS.THEME_TYPES_NAVI_B2B.find(theme => theme.value === data.tour.themeType);
    try {
      await this.itineraryService.updateItinerary({
        _id: data._id,
        b2b: updatePayload,
      });
      const params = new URLSearchParams({ rretMgxg: "nono" });
      const baseUrl = this.getHostnameUrl();
      this.clipboard.copy(`${baseUrl}${theme?.url}/${data._id}/${false}?${params.toString()}`);
      this.messageService.success(this.translocoService.translate("itineraries.messages.editableLinkCopied"));
      setTimeout(() => {
        location.reload();
      }, 2000);
    } catch (e) {
      this.messageService.success(this.translocoService.translate("itineraries.messages.generatingEditableLinkFailed"));
    }
  }

  getHostnameUrl(): string {
    return this.settingService.hostnameUrl || environment.previewLink;
  }

  showDeleteConfirm(id: string): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate("itineraries.modals.delete.title"),
      nzContent: this.translocoService.translate("itineraries.modals.delete.content"),
      nzOkText: this.translocoService.translate("itineraries.modals.delete.ok"),
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.deleteItinerary(id),
      nzCancelText: this.translocoService.translate("itineraries.modals.common.cancel"),
      nzOnCancel: () => console.log("Cancel"),
    });
  }

  showArchiveConfirm(id: string, archive: boolean): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate(
        !archive ? "itineraries.modals.archive.title" : "itineraries.modals.unarchive.title"
      ),
      nzContent: this.translocoService.translate(
        !archive ? "itineraries.modals.archive.content" : "itineraries.modals.unarchive.content"
      ),
      nzOkText: this.translocoService.translate(
        !archive ? "itineraries.modals.archive.ok" : "itineraries.modals.unarchive.ok"
      ),
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.archiveItinerary(id, archive),
      nzCancelText: this.translocoService.translate("itineraries.modals.common.cancel"),
      nzOnCancel: () => console.log("Cancel"),
    });
  }

  showRevokeAccessConfirm(id: string, access: boolean): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate(
        !access ? "itineraries.modals.access.enableTitle" : "itineraries.modals.access.disableTitle"
      ),
      nzContent: this.translocoService.translate(
        !access ? "itineraries.modals.access.enableContent" : "itineraries.modals.access.disableContent"
      ),
      nzOkText: this.translocoService.translate(
        !access ? "itineraries.modals.access.enableOk" : "itineraries.modals.access.disableOk"
      ),
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.revokeAccessItinerary(id, access),
      nzCancelText: this.translocoService.translate("itineraries.modals.common.cancel"),
      nzOnCancel: () => console.log("Cancel"),
    });
  }
  linkExpirationConfirm(id: string, expiration: boolean): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate(
        !expiration ? "itineraries.modals.linkExpiration.enableTitle" : "itineraries.modals.linkExpiration.disableTitle"
      ),
      nzContent: this.translocoService.translate(
        !expiration ? "itineraries.modals.linkExpiration.enableContent" : "itineraries.modals.linkExpiration.disableContent"
      ),
      nzOkText: this.translocoService.translate(
        !expiration ? "itineraries.modals.linkExpiration.enableOk" : "itineraries.modals.linkExpiration.disableOk"
      ),
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.revokeLinkExpiration(id, expiration),
      nzCancelText: this.translocoService.translate("itineraries.modals.common.cancel"),
      nzOnCancel: () => console.log("Cancel"),
    });
  }


  showViewNotificationConfirm(id: string, access: boolean): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate(
        !access ? "itineraries.modals.notifications.enableTitle" : "itineraries.modals.notifications.disableTitle"
      ),
      nzContent: this.translocoService.translate(
        !access ? "itineraries.modals.notifications.enableContent" : "itineraries.modals.notifications.disableContent"
      ),
      nzOkText: this.translocoService.translate(
        !access ? "itineraries.modals.notifications.enableOk" : "itineraries.modals.notifications.disableOk"
      ),
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.viewNotificationAccess(id, access),
      nzCancelText: this.translocoService.translate("itineraries.modals.common.cancel"),
      nzOnCancel: () => console.log("Cancel"),
    });
  }

  viewNotificationAccess(id: string, access: boolean): void {
    this.loading.start();
    this.itineraryService.updateItinerary({_id: id, isNotificationEnabled: !access}).then(() => {
      this.messageService.success(
        this.translocoService.translate(
          !access ? "itineraries.messages.notificationsEnabled" : "itineraries.messages.notificationsDisabled"
        )
      );
      this.loading.stop();
      this.onReload();
    });
  }

  sendItineraryShowModal(
    id: string,
    creator: string,
    customer: string,
    email: string,
    themeType: string
  ): void {
    this.modalTitle = this.translocoService.translate("itineraries.emailModal.sendItineraryTitle");
    this.modalTitleConfirmBox = this.translocoService.translate("itineraries.emailModal.sendItineraryConfirmTitle");
    this.subject = this.translocoService.translate("itineraries.emailModal.itinerarySubject");
    this.sendInfo = {
      id,
      creator,
      customer,
      email,
      type: "Itinerary",
      themeType
    };
    this.itineraryId = id;
    this.showModal();
  }

  sendInvoiceShowModal(
    id: string,
    customer: string,
    currency: string,
    costing: any,
    isDynamicPricing:boolean,
    adults: number,
    children: number,
    email: string,
    referenceNo: string,
    themeType: string
  ): void {
    this.modalTitle = this.translocoService.translate("itineraries.emailModal.sendInvoiceTitle");
    this.modalTitleConfirmBox = this.translocoService.translate("itineraries.emailModal.sendInvoiceConfirmTitle");
    this.subject = this.translocoService.translate("itineraries.emailModal.invoiceSubject", {
      referenceNo,
      customer
    });
    const numberOfPaxNum: number = adults + children;
    this.sendInfo = {
      id,
      customer,
      currency,
      costing,
      isDynamicPricing,
      numberOfPaxNum,
      email,
      referenceNo,
      type: "Invoice",
      themeType
    };
    this.showModal();
  }

  showModal(): void {
    if (this.sendInfo.email.length !== 0) {
      this.emailForm.patchValue({
        sendEmailTo: [this.sendInfo.email],
        sendEmailCc: [],
        sendEmailSubject: this.subject,
      });
    } else {
      this.messageService.warning(this.translocoService.translate("itineraries.messages.defaultCustomerEmailMissing"));
      this.emailForm.patchValue({
        sendEmailTo: [],
        sendEmailCc: [],
        sendEmailSubject: this.subject,
      });
    }

    this.sendEmailIsVisible = true;
  }

 async SendEmail(): Promise<void> {
    this.loading.start();
    this.sendEmailCancel("emailModal");
    const emailFormInfo = this.emailForm.getRawValue();
    let payload = {};

    // block to send pdf data or not
    if (this.sendInfo.type === "Itinerary" && this.attachWithPDFChecked) {
      const pdfData = await this.getPDFData(this.itineraryId);
      payload = {sendInfo: this.sendInfo, emailFormInfo, pdf: pdfData, isAttachPDF: this.attachWithPDFChecked, };
    }else{
      payload = {sendInfo: this.sendInfo, emailFormInfo};
    }

    if (this.sendInfo.type === "Itinerary") {
       try {
         this.loading.start();
         await this.itineraryService.emailSendToCustomerItinerary(payload);
         this.attachWithPDFChecked = false;
         await this.itineraryService.updateItinerary({ _id: this.sendInfo.id, isSent: true, isStatusUpdate: true, status: SETTINGS.ITINERARY_STATUSES.SENT });
         this.loading.stop();
         this.onReload();
         this.messageService.success(this.translocoService.translate("itineraries.messages.itinerarySent"));
       } catch (e: any) {
         this.attachWithPDFChecked = false;
         this.loading.stop();
         this.messageService.error(
           e?.error?.message || this.translocoService.translate("itineraries.messages.failedToSendItinerary")
         );
       }
   }

    if (this.sendInfo.type === "Invoice") {
       try {
         this.itineraryService.emailSendToCustomerItinerary(payload).then(() => {
           this.itineraryService.updateItinerary(
             {_id: this.sendInfo.id,
               status: SETTINGS.ITINERARY_STATUSES.INVOICE_SENT,
               isStatusUpdate: true,
               remarks: this.translocoService.translate("itineraries.messages.emailInvoiceSent")
             }).then(() => {
                 this.loading.stop();
                 this.messageService.success(this.translocoService.translate("itineraries.messages.invoiceSent"));
                 this.onReload();
             });
         });
       } catch (e) {
         this.attachWithPDFChecked = false;
         this.loading.stop();
         this.messageService.error(this.translocoService.translate("itineraries.messages.notSent"));
       }
   }
  }

  sendEmailConfirmModal(): void {
    this.sendEmailConfirmIsVisible = true;
  }

  sendEmailCancel(event: string): void {
    if (event === "emailModal") {
      this.sendEmailIsVisible = false;
      this.sendEmailConfirmIsVisible = false;
    } else {
      this.sendEmailConfirmIsVisible = false;
    }
  }

  async saleConvert(id: any, convertType: boolean): Promise<any> {
    this.loading.start();
    await this.itineraryService.updateItinerary({
      _id: id,
      saleConvert: !convertType,
    });
    // this.messageService.success(
    //   convertType === false
    //     ? 'Status changed to Payment Ready'
    //     : 'Status changed to Unconfirmed!'
    // );
    const keyword = this.itinerarySearchName;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
    });
    this.itineraryService.getPagedItineraries(payload).then((object: any) => {
      this.itineraries = object.data;
      this.pageSize.length = object.metadata[0]?.total;
      this.loading.stop();
    });
  }

  async onClickUpdateItinerary(data: any, status: string): Promise<void> {
    this.loading.start();

    switch (status) {
      case SETTINGS.ITINERARY_STATUSES.DRAFT:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.DRAFT,
          confirmedAt: "",
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
          saleConvert: false,
          isSent: false
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.DRAFT)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.SENT:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.SENT,
          confirmedAt: "",
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
          isSent: true
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.SENT)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.CANCELLED:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.CANCELLED,
          confirmedAt: "",
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
          saleConvert: false,
          isSent: false
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.CANCELLED)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.FOLLOW_UP:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.FOLLOW_UP,
          confirmedAt: "",
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
          saleConvert: false,
          isSent: false
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.FOLLOW_UP)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.CONFIRMED:
        const pdfData = await this.getPDFData(data._id);
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          confirmedAt: moment(),
          status: SETTINGS.ITINERARY_STATUSES.CONFIRMED,
          isStatusUpdate: true,
          saleConvert: true,
          statusRemarks: this.statusChangeRemarks,
          pdf: pdfData,
          isSent: false
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.CONFIRMED)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.INVOICE_SENT:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.INVOICE_SENT,
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.INVOICE_SENT)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.PAID:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          saleConvert: true,
          status: SETTINGS.ITINERARY_STATUSES.PAID,
          confirmedAt: moment(),
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.PAID)
          })
        );
        break;
      case SETTINGS.ITINERARY_STATUSES.LOST:
        this.statusChangeCancel();
        await this.itineraryService.updateItinerary({
          _id: data._id,
          status: SETTINGS.ITINERARY_STATUSES.LOST,
          isStatusUpdate: true,
          statusRemarks: this.statusChangeRemarks,
          saleConvert: false,
        });
        this.message.success(
          this.translocoService.translate("itineraries.messages.statusUpdated", {
            status: this.getTranslatedStatusLabel(SETTINGS.ITINERARY_STATUSES.LOST)
          })
        );
        break;
    }
    this.loading.stop();
    this.onReload();
  }

  getTranslatedStatusLabel(status: string): string {
    switch (status) {
      case SETTINGS.ITINERARY_STATUSES.DRAFT:
        return this.translocoService.translate("itineraries.list.statuses.draft");
      case SETTINGS.ITINERARY_STATUSES.SENT:
        return this.translocoService.translate("itineraries.list.statuses.sent");
      case SETTINGS.ITINERARY_STATUSES.FOLLOW_UP:
        return this.translocoService.translate("itineraries.list.statuses.followUp");
      case SETTINGS.ITINERARY_STATUSES.CONFIRMED:
        return this.translocoService.translate("itineraries.list.statuses.confirm");
      case SETTINGS.ITINERARY_STATUSES.INVOICE_SENT:
        return this.translocoService.translate("itineraries.list.statuses.invoiceSent");
      case SETTINGS.ITINERARY_STATUSES.PAID:
        return this.translocoService.translate("itineraries.list.statuses.paid");
      case SETTINGS.ITINERARY_STATUSES.LOST:
        return this.translocoService.translate("itineraries.list.statuses.lost");
      case SETTINGS.ITINERARY_STATUSES.CANCELLED:
        return this.translocoService.translate("itineraries.list.statuses.cancel");
      default:
        return status;
    }
  }

  getTranslatedTypeLabel(type: string): string {
    switch (type) {
      case "B2B":
        return this.translocoService.translate("itineraries.list.types.b2b");
      case "B2C":
        return this.translocoService.translate("itineraries.list.types.b2c");
      default:
        return type;
    }
  }

  getEmptyValue(): string {
    return this.translocoService.translate("itineraries.common.emptyValue");
  }

  getStatusColor(status: string): string {
    switch (status) {
      case SETTINGS.ITINERARY_STATUSES.DRAFT:
        return "gray";
        case SETTINGS.ITINERARY_STATUSES.SENT:
          return "green";
      case SETTINGS.ITINERARY_STATUSES.FOLLOW_UP:
        return "blue";

      case SETTINGS.ITINERARY_STATUSES.CONFIRMED:
        return "green";

      case SETTINGS.ITINERARY_STATUSES.INVOICE_SENT:
        return "yellow";

      case SETTINGS.ITINERARY_STATUSES.PAID:
        return "green";

      case SETTINGS.ITINERARY_STATUSES.LOST:
        return "red";
      case SETTINGS.ITINERARY_STATUSES.CANCELLED:
        return "red";
    }
    return "";
  }


  async loadItineraryByID(rId: string): Promise<any> {
    try {
      this.data = await this.itineraryService.getItineraryById({
        id: rId,
      });
      await this.settingService.findBrand(this.data.creator[0].creatorId);
      this.countrySequence();
      this.citySequence();
    } catch (e) {

    }
  }

  countrySequence(): void {
    this.data.days.forEach((day: any) => {
      const country = day?.destination?.country;
      if (!this.countries.includes(country) && country !== undefined) {
        this.countries.push(country);
      }
    });
  }

  citySequence(): void {
    this.data.days.forEach((day: any) => {
      const country = day?.destination?.country;
      const city = day?.destination?.city;

      const countryIndex = this.citiesByCountry.findIndex((item: any) => item?.country === country);

      if (countryIndex === -1) {
        this.citiesByCountry.push({country, cities: [city]});
      } else {
        // If country already exists, add city only if it's not already present
        if (!this.citiesByCountry[countryIndex].cities.includes(city)) {
          this.citiesByCountry[countryIndex].cities.push(city);
        }
      }
    });
  }

  generateSimpleWord(id: any): void {
    this.loading.start();
    let mapUrl: any = null;
    Promise.all([this.loadItineraryByID(id)]).then(async () => {
      mapUrl = this.data.viewSettings.mapType === SETTINGS.MAP_TYPES[0].value ?  await this.mapDirectionsImage() : this.mapImage();
      const countryImageURL = this.data?.tour?.customer?.country?.code ?
        this.findCountryFlagImage(this.data?.tour.customer.country.code) : "";
      const b2b = this.data?.tour?.type === "B2B" ? {
        itinerary: this.data?.itinerary,
        companyName: this.data?.b2b?.customer?.companyName || "",
        logo: this.data?.b2b?.customer?.logo,
        costing: this.data?.b2b?.costing,
        companyDetails: {summary: this.data?.b2b?.customer?.summary || "" , websiteLink: this.data?.b2b?.customer?.websiteLink || ""},
      } : "";
      const payload = {
        day: this.data.days.length,
        night: this.data.days.length - 1,
        clientTimezoneOffset: new Date().getTimezoneOffset(),
        ...this.data,
        ...this.organizationSetting,
        citiesByCountry: this.citiesByCountry,
        countries: this.countries,
        mapURL: mapUrl,
        countryImageURL,
        ...b2b
      };
      this.wordReportService.generateWordReport(payload).then((res) => {
        const fileName = `${this.data.tour.referenceNo}-${this.data?.b2b?.customer?.companyName ? this.data?.b2b?.customer?.companyName : this.translocoService.translate("itineraries.messages.noName")} `;
        this.wordReportService.downloadDocxReport(res, fileName);
        this.loading.stop();
      });
    });
  }

  exportContent(id: any, viewSettings: any, currentThemeType: string): void {
    this.nzModalService
      .create({
        nzClosable: false,
        nzTitle: this.translocoService.translate("itineraries.modals.export.title"),
        nzWidth: "700px",
        nzContent: ExportContentComponent,
        nzFooter: null,
        nzComponentParams: {
          id,
          viewSettings,
          currentThemeType
        },
      })
      .afterClose.subscribe(data => {
    });
  }

  findCountryFlagImage(countryCode: string): string {
    const selected_country = this.countriesJson.find(
      (c: any) => c.code === countryCode
    );
    return selected_country?.image;
  }
  async getCountries(): Promise<void> {
    this.countriesJson = await this.countryService.getCountries();
  }

  mapImage(): string {
    let geoJSON: any | undefined;

    if (this.data?.days[0]?.transport.length !== 0){
      const {locationFrom} = this.data?.days[0]?.transport[0];
      if (locationFrom){
        geoJSON = geoJSONManager(geoJSON, parseFloat(locationFrom?.latitude), parseFloat(locationFrom?.longitude));
      }
    }

    this.data.days.forEach((day: any) => {
      if (day?.destination) {
        const {location} = day?.destination;
        geoJSON = geoJSONManager(geoJSON, parseFloat(location?.latitude), parseFloat(location?.longitude));
      }
    });

    const lastDay = this.data.days.length - 1;
    if (this.data?.days[lastDay]?.transport.length !== 0){
      const lastTransport = this.data?.days[lastDay]?.transport.length - 1;
      const {locationTo} = this.data?.days[lastDay]?.transport[lastTransport];
      if (locationTo){
        geoJSON = geoJSONManager(geoJSON, parseFloat(locationTo?.latitude), parseFloat(locationTo?.longitude));
      }
    }

    return this.mapBoxService.getStaticMapURL(geoJSON);
  }

  async mapDirectionsImage(): Promise<any> {
    try {
      // Collect all waypoints from the itinerary
      const waypoints: Array<{lat: number, lng: number}> = [];

      // Add starting point from first transport
      if (this.data?.days[0]?.transport.length !== 0) {
        const {locationFrom} = this.data?.days[0]?.transport[0];
        if (locationFrom) {
          waypoints.push({
            lat: parseFloat(locationFrom.latitude),
            lng: parseFloat(locationFrom.longitude)
          });
        }
      }

      let prevId: string | undefined;
      // Add destination points
      for (const day of this.data?.days ?? []) {
        const dest = day?.destination;
        if (!dest?.location) {
          continue;
        }

        const curId = dest._id as string | undefined;
        if (curId && curId === prevId) {
          continue;
        }

        const {latitude, longitude} = dest.location;
        const lat = typeof latitude === "number" ? latitude : parseFloat(latitude);
        const lng = typeof longitude === "number" ? longitude : parseFloat(longitude);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          waypoints.push({lat, lng});
        }
        prevId = curId;
      }

      // Add ending point from last transport
      const lastDay = this.data.days.length - 1;
      if (this.data?.days[lastDay]?.transport.length !== 0) {
        const lastTransport = this.data?.days[lastDay]?.transport.length - 1;
        const {locationTo} = this.data?.days[lastDay]?.transport[lastTransport];
        if (locationTo) {
          waypoints.push({
            lat: parseFloat(locationTo.latitude),
            lng: parseFloat(locationTo.longitude)
          });
        }
      }
      return await this.mapBoxService.getStaticMapWithDirections(false, waypoints);
    } catch (e) {
      console.error('Error generating map image with directions:', e);
      return null;
    }
  }

  languageByCode(languageCode: any): string {
    const languageArray = this.languages;
    const languageName = languageArray.find(
      (element: any) => element.code === languageCode
    )?.name;

    if (!languageName) {
      return this.getEmptyValue();
    }
    return languageName;
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
    this.languageFilters = this.languages.map(language => {
      return {text: language.name, value: language.code};
    })
  }

  async getCreators(): Promise<void> {
    const response = await this.userService.getUsersDropdown();
    this.creators = (response || []).map((user: any) => ({
      _id: user._id,
      name: `${user.firstname.charAt(0).toUpperCase() + user.firstname.slice(1)} ${user.lastname.charAt(0).toUpperCase() + user.lastname.slice(1)}`
    }));
  }

  onCreatorChange(): void {
    this.pageSize.pageIndex = 1;
    this.search();
  }

  initializeColumnVisibility(): void {
    this.tableColumns.forEach(col => {
      this.columnVisibility[col.key] = true;
    });
  }

  async loadColumnPreferences(): Promise<void> {
    try {
      const preferenceKey = 'itineraryListColumns';
      const response = await this.userService.getUserPreference(preferenceKey);
      if (response?.tablePreference) {
        const savedVisibility = response.tablePreference as Record<string, boolean>;
        this.tableColumns.forEach(col => {
          if (savedVisibility[col.key] !== undefined) {
            this.columnVisibility[col.key] = savedVisibility[col.key];
          }
        });
      }
    } catch (e) {
      // If backend fails, keep defaults
    }
  }

  isColumnVisible(key: string): boolean {
    return this.columnVisibility[key] ?? true;
  }

  openTableViewModal(): void {
    this.tempColumnVisibility = { ...this.columnVisibility };
    this.isTableViewModalVisible = true;
  }

  closeTableViewModal(): void {
    this.isTableViewModalVisible = false;
  }

  async updateTableView(): Promise<void> {
    this.columnVisibility = { ...this.tempColumnVisibility };
    try {
      const preferenceKey = 'itineraryListColumns';
      await this.userService.saveUserPreference(preferenceKey, this.columnVisibility);
      this.messageService.success(this.translocoService.translate('itineraries.messages.tableViewUpdated'));
    } catch (e) {
      this.messageService.error(this.translocoService.translate('itineraries.messages.tableViewUpdateFailed'));
    }
    this.closeTableViewModal();
  }

  async onDuplicateItinerary(id: any): Promise<void> {
    this.loading.start();

    try {
      const itinerary = await this.itineraryService.getItineraryById({id});
      const payload = {
        title: itinerary.title,
        tour: itinerary.tour,
        experiences: itinerary.experiences,
        accommodation: itinerary.accommodation,
        days: itinerary.days,
        viewSettings: itinerary.viewSettings,
        costSettings: itinerary?.costSettings || {},
        costing: itinerary.costing,
        paymentLink: itinerary.paymentLink || "",
        isSent: false,
        saleConvert: false,
        featured: itinerary.featured,
        itinerary: itinerary.itinerary,
        status: SETTINGS.ITINERARY_STATUSES.DRAFT,
        confirmAt: null,
        images: itinerary.images
      };
      this.messageService.success(this.translocoService.translate("itineraries.messages.duplicatedSuccessfully"));
      await this.itineraryService.createItinerary(payload);
      this.onReload();

    } catch (e) {
      this.loading.stop();

    }
  }
  async saveAsTemplate(id: any): Promise<void> {
    this.loading.start();

    try {
      const itinerary = await this.itineraryService.getItineraryById({ id });
      const {
        _id,
        lock,
        createdAt,
        updatedAt,
        isSharingEnabled,
        isCreatedFromTemplate,
        status,
        creator,
        ...itineraryData
      } = itinerary;

      const payload: any = {
        ...itineraryData,
        tour: {
          ...this.stripTopLevelIds(itineraryData.tour || {}),
          isDatesOptional: true,
        },
        itinerary: this.stripTopLevelIds(itineraryData.itinerary || {}),
        title: itineraryData.title || '',
        days: this.stripTopLevelIds(itineraryData.days || []).map((day: any) => ({
          ...this.stripTopLevelIds(day),
          transport: this.stripTopLevelIds(day?.transport || []).map((t: any) => this.stripTopLevelIds(t)),
        })),
        accommodation: this.stripTopLevelIds(itineraryData.accommodation || []),
        images: this.stripTopLevelIds(itineraryData.images || []),
        experiences: this.stripTopLevelIds(itineraryData.experiences || []).map((exp: any) => ({
          ...this.stripTopLevelIds(exp),
          experiencesPerDay: this.stripTopLevelIds(exp?.experiencesPerDay || []).map((epd: any) => this.stripTopLevelIds(epd)),
        })),
        costing: {
          ...this.stripTopLevelIds(itineraryData.costing || {}),
          additionalCosts: this.stripTopLevelIds((itineraryData.costing || {}).additionalCosts || []),
        },
        featured: this.stripTopLevelIds(itineraryData.featured || {}),
        viewSettings: this.stripTopLevelIds(itineraryData.viewSettings || {}),
        costSettings: this.stripTopLevelIds(itineraryData.costSettings || {}),
        paymentLink: itineraryData.paymentLink || '',
        remarks: itineraryData.remarks || '',
        excludePredefinedCost: itineraryData.excludePredefinedCost || false,
      };

      if (payload.tour) {
        ['customer', 'agent', 'selectedContact', 'category'].forEach((key) => {
          const v = payload.tour[key];
          if (v == null || v === '' || v === 'undefined' || v === undefined) {
            delete payload.tour[key];
          }
        });
      }

      await this.itineraryTemplatesService.createTemplateFromItinerary(payload);
      this.loading.stop();
      this.messageService.success(this.translocoService.translate('itineraryTemplates.messages.saveAsTemplate'));
      this.router.navigate(['/admin/itineraries/template']);
    } catch (e) {
      this.loading.stop();
      this.messageService.error(this.translocoService.translate('itineraryTemplates.messages.failedToAdd'));
    }
  }

  private stripTopLevelIds(data: any): any {
    if (Array.isArray(data)) {
      return data.map((item: any) => {
        if (item && typeof item === 'object' && !Array.isArray(item)) {
          const { _id, ...rest } = item;
          return rest;
        }
        return item;
      });
    }
    if (data && typeof data === 'object') {
      const { _id, ...rest } = data;
      return rest;
    }
    return data;
  }

  async getPDFData(id: any): Promise<any> {
    try {
      let mapUrl: any = null;
      return await this.loadItineraryByID(id).then(async itinerary => {
        mapUrl = this.data.viewSettings.mapType === SETTINGS.MAP_TYPES[0].value ? await this.mapDirectionsImage() : this.mapImage();
        const countryImageURL = this.data?.tour?.customer?.country?.code ?
          this.findCountryFlagImage(this.data?.tour.customer.country.code) : "";
        const b2b = this.data?.tour?.type === "B2B" ? {
          itinerary: this.data?.itinerary,
          companyName: this.data?.b2b?.customer?.companyName || "",
          logo: this.data?.b2b?.customer?.logo,
          costing: this.data?.b2b?.costing,
          companyDetails: {
            summary: this.data?.b2b?.customer?.summary || "",
            websiteLink: this.data?.b2b?.customer?.websiteLink || ""
          },
        } : "";
        const payload = {
          day: this.data.days.length,
          night: this.data.days.length - 1,
          ...this.data,
          ...this.organizationSetting,
          citiesByCountry: this.citiesByCountry,
          countries: this.countries,
          mapURL: mapUrl,
          ...b2b,
          countryImageURL,
          pdfViewOptions: SETTINGS.PDF_VIEW_OPTIONS
        };
        return payload;
      });
    }catch (e) {
      console.log(e);
    }

  }

  onClickNavigateToPreview(inti: any): void {
    const theme = SETTINGS.THEME_TYPES_NAVI_B2C.find(theme => theme.value === inti.tour.themeType);
    const params = new URLSearchParams({ rretMgxg: "ffliwqadrjt" });
    const baseUrl = this.getHostnameUrl();
    window.open(`${baseUrl}${theme?.url}/${inti._id}/false?${params.toString()}`, "_blank");
  }

  viewAgentContent(id: any): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.modals.agentInformation.title"),
        nzWidth: "800px",
        nzContent: ViewAgentComponent,
        nzFooter: null,
        nzComponentParams: {
          id
        },
      })
      .afterClose.subscribe(data => {
    });
  }

  statusChangeCancel(): void {
    this.isStatusChangeVisible = false;
    this.selectedStatus = "";
    this.selectedItinerary = null;
  }
  statusChangeOpenModel(data: any, status: string): void {
    this.isStatusChangeVisible = true;
    this.selectedStatus = status;
    this.selectedItinerary = data;
  }

  onChangeSwitch(value: boolean): void {
    this.archieved = value;
    this.languageFilters = this.languageFilters.map(f => ({ ...f, byDefault: false }));
    this.typeFilters = this.typeFilters.map(f => ({ ...f, byDefault: false }));
    this.statusFilters = this.statusFilters.map(f => ({ ...f, byDefault: false }));
    this.search();
  }

  onReload(): void {
    this.loading.start();
    const keyword = this.itinerarySearchName;
    const langVals = this.pageSize.filter.find((f:any) => f.key === 'language')?.value ?? [];
    const typeVals = this.pageSize.filter.find((f:any) => f.key === 'type')?.value ?? [];
    const statusValRaw = this.pageSize.filter.find((f:any) => f.key === 'status')?.value;
    const statusVals = Array.isArray(statusValRaw) ? statusValRaw : statusValRaw != null ? [statusValRaw] : [];
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      archieved: this.archieved,
      langKeyword: langVals.length !== 0 ? langVals : "",
      type: typeVals.length !== 0 ? typeVals : "",
      status: statusVals.length !== 0 ? statusVals[0] : "",
      creator: this.selectedCreator || "",
      keyword,
    });
    this.itineraryService.getPagedItineraries(payload).then((object: any) => {
      this.itineraries = object.data;
      this.pageSize.length = object.metadata[0]?.total;
      this.statusChangeRemarks = "";
      this.loading.stop();
    });
  }
}
